// @ts-nocheck
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import api from 'lib/Api';
import alertActions from 'ducks/alert/actions';
import { alertTypesConstants, myArticlesConstants } from 'commons/constants';
import type {
  ArticlesPayload,
  GetArticleCoverImagesPayload,
  GetBySlugPayload,
} from 'commons/types';
import {
  getArticleByIdTypes,
  getArticleBySlugTypes,
  getArticleCoverImagesTypes,
  getArticlesTypes,
  getTaxonomyArticlesTypes,
} from './types';
import articlesActions from './actions';

const { DANGER } = alertTypesConstants;
type getArticleSagaInterface = {
  payload: ArticlesPayload;
};
export function* getArticleByIdSaga({ payload }: { payload: number }): Saga<void> {
  try {
    const article = yield call([api.article, 'getById'], payload);
    yield put(articlesActions.getArticleByIdSuccess(article));
  } catch (error) {
    yield put(articlesActions.getArticleByIdFail(myArticlesConstants.ARTICLE_FETCH_FAILURE));
  }
}
export function* getArticleBySlugSaga({ payload }: { payload: GetBySlugPayload }): Saga<void> {
  try {
    const article = yield call([api.article, 'getBySlug'], payload);
    yield put(articlesActions.getArticleBySlugSuccess(article));
  } catch (error) {
    yield put(articlesActions.getArticleBySlugFail(myArticlesConstants.ARTICLE_FETCH_FAILURE));
  }
}
export function* getArticlesInternalSaga({ payload }: getArticleSagaInterface): Saga<void> {
  try {
    const articles = yield call([api.article, 'getArticles'], payload);
    yield put(articlesActions.getArticlesInternalSuccess(articles));
  } catch (error) {
    const message = myArticlesConstants.ARTICLE_LIST_FETCH_FAILURE;
    yield put(
      alertActions.setAlert({
        message,
        type: DANGER,
      }),
    );
    yield put(articlesActions.getArticlesInternalFail(message));
  }
}
export function* getTaxonomyArticlesSaga({ payload }: getArticleSagaInterface): Saga<void> {
  try {
    const articles = yield call([api.article, 'getTaxonomyArticles'], payload);
    yield put(articlesActions.getTaxonomyArticlesSuccess(articles));
  } catch (error) {
    const message = myArticlesConstants.ARTICLE_LIST_FETCH_FAILURE;
    yield put(
      alertActions.setAlert({
        message,
        type: DANGER,
      }),
    );
    yield put(articlesActions.getTaxonomyArticlesFailure(message));
  }
}
export function* getArticlesCoverImagesSaga({
  payload,
}: {
  payload: GetArticleCoverImagesPayload;
}): Saga<void> {
  try {
    const { searchTerm, page } = payload;
    const coverImages = yield call([api.article, 'searchImagesForArticle'], searchTerm, page);
    yield put(
      articlesActions.getArticleCoverImagesSuccess({
        coverImages,
        page,
      }),
    );
  } catch (error) {
    const message = 'There was an error fetching the articles cover images. Try again later';
    yield put(articlesActions.getArticleCoverImagesFail(message));
    yield put(
      alertActions.setAlert({
        message,
        type: DANGER,
      }),
    );
  }
}
export default function* articleSaga(): Saga<void> {
  yield takeEvery(getArticleByIdTypes.REQUEST, getArticleByIdSaga);
  yield takeEvery(getArticleBySlugTypes.REQUEST, getArticleBySlugSaga);
  yield takeEvery(getArticlesTypes.REQUEST, getArticlesInternalSaga);
  yield takeLatest(getTaxonomyArticlesTypes.REQUEST, getTaxonomyArticlesSaga);
  yield takeLatest(getArticleCoverImagesTypes.REQUEST, getArticlesCoverImagesSaga);
}
